import classNames from "classnames";

export default function  ToolbarComponent({children, className}) {
    const classes = classNames(
        'flex flex-row justify-start border-black border-l-4', 
        className
    );

    return (
        <div className={classes}>
            {children}
        </div>
    )
}